import { useParams } from "react-router-dom";

import { apiHooks } from "../../api/index.js";
import { createRoute } from "../../routing/createRoute.js";
import {
  AdminUserPageContent,
  useManagedAccount,
} from "../Admin/AdminUserPage.js";

/**
 * One account, as an organisation's admin maintaining it sees it.
 *
 * Its organisations are not linked: the organisation pages are Thalamos's own
 * administration, which this session cannot open.
 */
export const OrganisationUserPage = () => {
  const { userId } = useParams();

  // `useParams` types every segment as optional, but the route cannot match
  // without this one.
  const account = useManagedAccount(userId ?? "");

  // A short, fixed list, so both pickers share the one read and filter it here.
  const [{ data }] = apiHooks.user.provisionableOrganisations();
  const organisations = data?.organisations ?? [];

  return (
    <AdminUserPageContent
      {...account}
      backTo={createRoute.users()}
      organisations={organisations}
      adminOrganisations={organisations}
    />
  );
};
